import React from 'react';
import PropTypes from "prop-types"
import styled from '@emotion/styled';
import { Link } from 'gatsby';
import RightArrowIcon from '/static/icons/arrows/arrow-right.svg';
import LeftArrowIcon from '/static/icons/arrows/arrow-left.svg';

const Wrapper = styled.div`
  display: flex;
  a {
    margin-left: ${props => props.marginLeft};
    color: ${props => props.theme.colors.blue};
    display: flex;
    align-items: center;
    &:hover {
      color: ${props => props.theme.colors.black};
      p {
        text-decoration: underline;
      }
    }
    p {
      margin: 0px;
    }
    cursor: pointer;
  }
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    padding-left: 20px;
  }
`;

const StyledLeftArrowIcon = styled(LeftArrowIcon) `
  margin: 0px;
  margin-right: 8px;
`
const StyledRightArrowIcon = styled(RightArrowIcon) `
  margin: 0px;
  margin-left: 8px;
`

const LinkButton = ({link, text, rightIcon, visible}) => {
  return (
    <Wrapper className={visible?"visible":"non-visible"} marginLeft={rightIcon ? "auto" : "0px"}>
      <Link to={link}>
        {!rightIcon && 
          <StyledLeftArrowIcon />
        }
        <p>{text}</p>
        {rightIcon && 
          <StyledRightArrowIcon />
        }
      </Link>
    </Wrapper>
  )
}

LinkButton.propTypes = {
  link: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  rightIcon: PropTypes.bool,
  visible: PropTypes.bool
}
LinkButton.defaultProps = {
  rightIcon: false,
  visible: true,
};

export default LinkButton;